<template>
    <div>
        <div class="modal fade bs-example-modal-lg" tabindex="-1" role="dialog" id="ventilationModal">
            <div class="modal-dialog modal-lg" v-if="this.getOperationSelected">
                <div class="modal-content">
                    <div class="overlay ModalOverlay" v-if="getLoadingModalOperation">
                        <i class="fa fa-refresh fa-spin"></i>
                    </div>

                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                                aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">
                            Ventiler l'opération
                            <button class="btn btn-primary dropdown-toggle" style="padding: 1px 4px 1px 4px;"
                                    type="button" data-toggle="collapse" data-target="#detailsOperations"
                                    aria-expanded="false" aria-controls="detailsOperations">
                                <span class="caret"></span>
                            </button>
                            <div class="pull-right" v-if="this.getOperationSelected">
                                <h4>Reste: <span
                                        :class="[{'green' : this.getOperationSelected.reste_ventilation.ResteVentilation==0, 'red': this.getOperationSelected.reste_ventilation.ResteVentilation!=0}]">{{this.getOperationSelected.reste_ventilation.ResteVentilation}} €</span>
                                    à ventiler
                                </h4>
                            </div>
                        </h4>

                    </div>

                    <div class="modal-body row">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div class="callout animated"
                                 :class="[{'callout-success':ajax.success,'callout-danger':!ajax.success}]"
                                 v-show="callout" transition="callout">
                                <h4>{{ ajax.success ? 'Done!' : 'Attention!' }}</h4>
                                <p>{{ajax.message}}</p>
                            </div>

                            <div class="callout animated callout-success"
                                 v-show="this.getOperationSelected.reste_ventilation.ResteVentilation==0"
                                 transition="callout">
                                <h4>Done!</h4>
                                <p>Cette opération a été totalement ventilée</p>
                            </div>

                            <div class="collapse" id="detailsOperations" v-if="this.getOperationSelected">
                                <div class="detail-row well">
                                    <div class="form-group">
                                        <label>De: </label>
                                        <span>{{ this.getOperationSelected.compte_de.proprietaire.nom }} </span>
                                    </div>
                                    <div class="form-group">
                                        <label>Vers: </label>
                                        <span>{{ this.getOperationSelected.compte_vers.proprietaire.nom }} </span>
                                    </div>
                                    <div class="form-group">
                                        <label>Date comptable: </label>
                                        <span>{{date_comptable_format }} </span>
                                    </div>
                                    <div class="form-group">
                                        <label>Date valeur: </label>
                                        <span>{{date_valeur_format }} </span>
                                    </div>
                                    <div class="form-group">
                                        <label>Détails: </label>
                                        <span>{{details_format}}</span>
                                    </div>
                                    <div class="form-group">
                                        <label>Communication: </label>
                                        <span>{{ this.getOperationSelected.communication }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"
                                 v-if="this.getOperationSelected.reste_ventilation.ResteVentilation!=0">
                                <div class="box" :class="[{'box-solid box-danger': errorsVentilation.rubrique }]">
                                    <div class="box-header">
                                        <h3 class="box-title">Catégorie</h3>
                                    </div>
                                    <div class="box-body">
                                        <div class="panelBtns animated" v-show="showPanel" transition="rubriqueBtns">
                                            <button class="btn btn-block btn-default" v-if="childrenTree>0"
                                                    @click="loadParent()"><i class="glyphicon glyphicon-chevron-left"
                                                                             style="float:left; margin-top:2px"></i>Retour
                                            </button>
                                            <template v-for="rubrique in rubriquesCurrent">
                                                <a class="btn btn-block btn-default btnRubrique"
                                                   :class="[{'active':rubrique==rubriqueSelected, 'btn-info': rubrique==rubriqueSelected && rubrique.enfants.length==0}]"
                                                   @click.prevent="loadChildren(rubrique)">
                                                    {{rubrique.rubrique.description}}
                                                    <i class="glyphicon glyphicon-chevron-right"
                                                       style="float:right; margin-top:2px"
                                                       v-if=" rubrique.enfants.length>0"></i>
                                                </a>
                                            </template>
                                        </div>

                                    </div>
                                </div>
                                <div class="box">
                                    <div class="box-header">
                                        <h3 class="box-title">Raccourcis</h3>
                                    </div>
                                    <div class="box-body table-responsive no-padding">
                                        <table class="table table-bordered text-center">
                                            <tbody>
                                            <tr>
                                                <td @click.prevent="operationMontant('=all')">
                                                    <button class="btn btn-block btn-default btn-sm">Tout</button>
                                                </td>
                                                <td>
                                                    <button @click.prevent="operationMontant('/2')"
                                                            class="btn btn-block btn-default btn-sm">La moitié
                                                    </button>
                                                </td>
                                                <td>
                                                    <button @click.prevent="operationMontant('=0')"
                                                            class="btn btn-block btn-default btn-sm">0€
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <button @click.prevent="operationMontant('=35')"
                                                            class="btn btn-block btn-default btn-sm">35€
                                                    </button>
                                                </td>
                                                <td>
                                                    <button @click.prevent="operationMontant('=70')"
                                                            class="btn btn-block btn-default btn-sm">70€
                                                    </button>
                                                </td>
                                                <td>
                                                    <button @click.prevent="operationMontant('=105')"
                                                            class="btn btn-block btn-default btn-sm">105€
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr style="border-top:3px solid #f4f4f4">
                                                <td>
                                                    <button @click.prevent="operationMontant('+5')"
                                                            class="btn btn-block btn-default btn-sm">+5€
                                                    </button>
                                                </td>
                                                <td>
                                                    <button @click.prevent="operationMontant('+10')"
                                                            class="btn btn-block btn-default btn-sm">+10€
                                                    </button>
                                                </td>
                                                <td>
                                                    <button @click.prevent="operationMontant('+20')"
                                                            class="btn btn-block btn-default btn-sm">+20€
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <button @click.prevent="operationMontant('-5')"
                                                            class="btn btn-block btn-default btn-sm">-5€
                                                    </button>
                                                </td>
                                                <td>
                                                    <button @click.prevent="operationMontant('-10')"
                                                            class="btn btn-block btn-default btn-sm">-10€
                                                    </button>
                                                </td>
                                                <td>
                                                    <button @click.prevent="operationMontant('-20')"
                                                            class="btn btn-block btn-default btn-sm">-20€
                                                    </button>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>

                            <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8"
                                 v-if="this.getOperationSelected.reste_ventilation.ResteVentilation!=0">
                                <div class="box">
                                    <div class="box-header">
                                        <h3 class="box-title">Informations</h3>
                                    </div>
                                    <div class="box-body">
                                        <form method="POST" id="searchForm" class="AutocompleteComponent searchForm"
                                              action="">
                                            <div class="form-group" :class="{ 'has-error': errorsVentilation.montant }">
                                                <label for="MontantDe">Montant</label>
                                                <div class="input-group">
                                                    <span class="input-group-addon">€</span>
                                                    <input type="text" name="montant" class="form-control"
                                                           id="MontantDe" v-model="montant" placeholder=""
                                                           onClick="this.select();">
                                                </div>
                                            </div>
                                        </form>
                                        <div class="form-group">
                                            <label>Commentaires (optionnel)</label>
                                            <textarea v-model="commentaire" class="form-control" rows="3"
                                                      placeholder="Commentaire..."></textarea>
                                        </div>
                                        <hr/>
                                        <label for="MontantDe">Lier un membre</label>
                                        <searchmember
                                                :limit="5"
                                                :min-chars="3"
                                                action-on-hit="majAllUsersSelected"
                                                :follow-link-on-click-on-item="false"
                                        >
                                        </searchmember>

                                        <list-of-members-link
                                                :send-ajax="false"
                                        >
                                        </list-of-members-link>

                                        <hr/>
                                        <label for="MontantDe">Lier un club</label>
                                        <searchclub
                                                :limit="5"
                                                :min-chars="3"
                                                :follow-link-on-click-on-item="false"
                                                action-on-hit="majAllClubsSelected"
                                        >
                                        </searchclub>
                                        <list-of-clubs-link
                                                :send-ajax="false"
                                        >
                                        </list-of-clubs-link>
                                        <hr/>
                                        <upload-file
                                                help="Message d'aide"
                                                file-type="all"
                                                linkOnUpload=""
                                        >
                                        </upload-file>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <template v-if="this.getOperationSelected">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                                 v-if="this.getOperationSelected.facture_operation.length >0">
                                <div class="box">
                                    <div class="box-header">
                                        <h3 class="box-title">Ventilations</h3>
                                    </div>
                                    <div class="box-body">
                                        <table class="table table-hover">
                                            <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Montant</th>
                                                <th>Catégorie</th>
                                                <th>Commentaire</th>
                                                <th>Ajouté par</th>
                                                <th>Action</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(ventilation,index) in this.getOperationSelected.facture_operation">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ ventilation.montant }} €</td>
                                                <td>{{ ventilation.rubrique.description }}</td>
                                                <td>{{ ventilation.commentaire }}</td>
                                                <td>{{ ventilation.log[0].user }}</td>
                                                <td>
                                                    <button class="btn btn-danger" style="padding:0"
                                                            @click.prevent="deleteVentilation(ventilation)">
                                                        <i class="glyphicon glyphicon-remove"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Fermer</button>
                        <button type="button" @click.prevent="ventileOperation" class="btn btn-primary"
                                v-if="this.getOperationSelected.reste_ventilation.ResteVentilation>0">
                            {{ filesAdded ? "Sauvegarder et envoyer les fichiers" : "Sauvegarder" }}
                        </button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
    var moment = require('moment');
    var _ = require('underscore')
    import {mapGetters, mapActions} from 'vuex'
    import listOfMembersLink from "./listOfMembersLink"
    import listOfClubsLink from "./listOfClubsLink"
    import uploadFile from "../Communs/UploadFile"

    export default {
        props: {},
        data() {
            return {
                rubriquesEntrees: null,
                rubriquesSorties: null,
                entree: true,
                callout: false,
                ajax: {
                    show: false,
                    success: false,
                    message: ""
                },
                commentaire: null,
                rubriquesCurrent: [],
                showPanel: false,
                rubriqueSelected: {},
                previousRubrique: {},
                childrenTree: 0,
                errorsVentilation: {
                    rubrique: false,
                    montant: false
                },
                montant: 0,
                filesAdded: false,
                routeSearchMembre: null,
                routeSearchClub: null,
                routeClickOnItem: ""
            }
        },
        computed: {
            ...mapGetters({
                getOperationSelected: 'getOperationSelected',
                getRoute: 'getRoute',
                allClubsSelected: 'getAllClubsSelected',
                allUsersSelected: 'getAllUsersSelected',
                searchResults: 'getSearchResults',
                getRubriquesSorties: 'getRubriquesSorties',
                getRubriquesEntrees: 'getRubriquesEntrees',
                getLoadingModalOperation: 'getLoadingModalOperation'
            }),
            date_comptable_format: function () {
                return moment(this.getOperationSelected.date_comptable, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY')
            },
            date_valeur_format: function () {
                return moment(this.getOperationSelected.date_valeur, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY')
            },
            details_format: function () {
                return this.getOperationSelected.details.replace(/\\n|\\r\\n|\\r/g, "\n")
            }
        },
        methods: {
            ...mapActions({
                removeVentilationFromOperationSelected: "removeVentilationFromOperationSelected",
                addVentilationFromOperationSelected: "addVentilationFromOperationSelected",
                majOperationInSearchResults: "majOperationInSearchResults",
                reinitAllUsersSelected: "reinitAllUsersSelected",
                reinitAllClubsSelected: "reinitAllClubsSelected",
                majLoadingModalOperation: "majLoadingModalOperation",
                sendSticky: "sendSticky"
            }),
            deleteVentilation: function (ventilation) {
                var these = this;

                these.majLoadingModalOperation(true)
                this.$http.delete(this.getRoute('deleteVentilation') + ventilation.id).then(function (response) {
                    these.majLoadingModalOperation(false)
                    this.ajax.success = true
                    this.ajax.message = response.data.message
                    this.callout = true
                    this.removeVentilationFromOperationSelected(response.data.ventilation)
                    this.majOperationInSearchResults(this.getOperationSelected)
                }, (response) => {
                    these.majLoadingModalOperation(false)
                    this.ajax.success = false
                    this.ajax.message = response.data.message;
                    this.callout = true
                });
            },
            champsCorrect: function () {
                this.errorsVentilation.rubrique = (!_.isEmpty(this.rubriqueSelected.enfants) || _.isEmpty(this.rubriqueSelected)) ? true : false
                this.errorsVentilation.montant = (parseFloat(this.montant) == 0) ? true : false
                return !_.contains(this.errorsVentilation, true)
            },
            params: function () {
                var params = {}
                params.idOperation = this.getOperationSelected.id
                params.idRubrique = this.rubriqueSelected.rubrique.id
                params.montant = this.montant
                params.commentaire = this.commentaire
                params.membresLies = this.allUsersSelected
                params.clubsLies = this.allClubsSelected

                return params
            },
            ventileOperation: function () {
                var these = this;
                if (!this.champsCorrect())
                    return false
                these.majLoadingModalOperation(true)
                this.$http.post(this.getRoute('addVentilation'), this.params()).then(function (response) {
                    these.majLoadingModalOperation(false)
                    this.ajax.success = true
                    this.ajax.message = response.data.message;
                    this.callout = true
                    this.addVentilationFromOperationSelected(response.data.ventilation)
                    this.majOperationInSearchResults(this.getOperationSelected)
                }, (response) => {
                    these.majLoadingModalOperation(false)
                    this.ajax.success = false
                    this.ajax.message = response.data.message;
                    this.callout = true
                });

            },
            operationMontant(operationMontant) {
                switch (operationMontant.charAt(0)) {
                    case '+':
                        this.montant = parseFloat(this.montant) + parseFloat(operationMontant.substring(1))
                        break
                    case '-':
                        this.montant -= operationMontant.substring(1)
                        break
                    case '/':
                        this.montant /= operationMontant.substring(1)
                        break
                    case '*':
                        this.montant *= operationMontant.substring(1)
                        break
                    case '=':
                        if (operationMontant.substring(1) == 'all')
                            this.montant = this.getOperationSelected.reste_ventilation.ResteVentilation
                        else this.montant = operationMontant.substring(1)
                        break
                }
            },
            loadChildren(rubrique) {
                if (rubrique.enfants.length > 0) {
                    this.showPanel = false
                    this.previousRubrique = this.rubriquesCurrent
                    this.rubriquesCurrent = rubrique.enfants
                    this.childrenTree++
                    this.showPanel = true
                }
                else
                    this.rubriqueSelected = rubrique
            },
            loadParent() {
                this.rubriquesCurrent = this.previousRubrique
                this.rubriqueSelected = {}
                this.previousRubrique = {}
                this.childrenTree--
            },
            reinit: function () {
                this.callout = false,
                    this.ajax = {
                        show: false,
                        success: false,
                        message: ""
                    },
                    this.commentaire = null,
                    this.rubriquesCurrent = [],
                    this.showPanel = false,
                    this.rubriqueSelected = {},
                    this.previousRubrique = {},
                    this.childrenTree = 0,
                    this.errorsVentilation = {
                        rubrique: false,
                        montant: false
                    },
                    this.montant = 0,
                    this.majLoadingModalOperation(false)
                this.filesAdded = false
                this.rubriquesCurrent = this.entree ? this.rubriquesEntrees : this.rubriquesSorties;
                this.showPanel = true
                this.reinitAllClubsSelected()
                this.reinitAllUsersSelected()
            }
        },
        watch: {
            montant: function (montant) {
                this.montant = parseFloat(montant).toFixed(2);
                if (this.montant < 0)
                    this.montant = 0
            },
            getOperationSelected: function (op) {
                this.reinit()
                this.montant = op.montant
                this.entree = op.entree
            },
            entree: function (entree) {
                this.rubriquesCurrent = entree ? this.rubriquesEntrees : this.rubriquesSorties;
            },
            getRubriquesEntrees: function () {
                this.rubriquesEntrees = this.getRubriquesEntrees
            },
            getRubriquesSorties: function () {
                this.rubriquesSorties = this.getRubriquesSorties
            },
        },
        // beforeRouteEnter(to, from, next) {
        //     next(vm => {
        //         vm.rubriquesEntrees = vm.getRubriquesEntrees
        //         vm.rubriquesSorties = vm.getRubriquesSorties
        //         vm.routeSearchMembre = vm.getRoute('memberSearch')
        //         vm.routeSearchClub = vm.getRoute('clubSearch')
        //         vm.rubriquesCurrent = vm.entree ? vm.rubriquesEntrees : vm.rubriquesSorties;
        //         vm.showPanel = true;
        //     })
        // },
        mounted: function () {
            this.rubriquesEntrees = this.getRubriquesEntrees
            this.rubriquesSorties = this.getRubriquesSorties
            this.routeSearchMembre = this.getRoute('memberSearch')
            this.routeSearchClub = this.getRoute('clubSearch')

            this.$nextTick(function () {
                // console.log("coco");
                this.rubriquesCurrent = this.entree ? this.rubriquesEntrees : this.rubriquesSorties;
                this.showPanel = true;
            });
        },
        events: {
            'filesAdded': function (added) {
                this.filesAdded = added
            }
        },
        components: {
            listOfMembersLink,
            listOfClubsLink,
            uploadFile
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Operations/ventilation.vue